import { typographyVariants } from '@mint-lib/tw-components';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import { TooltipContentProps as RechartsTooltipProps } from 'recharts/types/component/Tooltip.js';

import { formatLabel } from '../../../helpers/charts.js';
import ChartTooltip from '../ChartTooltip/ChartTooltip.jsx';

type TooltipProps = RechartsTooltipProps<ValueType, NameType>;
const ScatterTooltip = ({ active, payload }: TooltipProps) => {
  if (!active || !payload?.length) {
    return null;
  }

  return (
    <ChartTooltip className="flex-row">
      <div
        style={{ backgroundColor: payload[0].payload.fill }}
        className="flex min-h-full w-1 flex-col items-center"
      />

      <div className="flex flex-col gap-2">
        {payload[0].payload.label && (
          <p
            className={typographyVariants({
              variant: 'bodyShort01',
            })}
          >
            {payload[0].payload.label}
          </p>
        )}
        {payload.map((data) => (
          <div className="flex flex-row" key={data.value as number}>
            <div className="flex flex-col">
              <p
                className={typographyVariants({
                  variant: 'bodyShort01',
                })}
              >
                {data.value}
              </p>
              <p
                className={typographyVariants({
                  variant: 'label01',
                })}
              >
                {typeof data.name === 'string'
                  ? formatLabel({
                      label: data.name,
                    })
                  : data.name}
              </p>
            </div>
          </div>
        ))}
      </div>
    </ChartTooltip>
  );
};

export default ScatterTooltip;
